export enum KnmReasonChangeTypeOperationEnum {
  EXCLUDE = 'EXCLUDE',
  CHANGE = 'CHANGE',
  INCLUDE = 'INCLUDE',
}
